import useSWR from "swr";
import { useCreateUserPlatformServiceAxiosInstance } from "../UserPlatformService/useCreateUserPlatformServiceAxiosInstance.ts";
import {
  ListIssuedGiftCardsParams,
  ListIssuedGiftCardsResponse,
} from "./types.ts";

export function useIssuedGiftCards(params: ListIssuedGiftCardsParams) {
  const { createUserPlatformServiceAxiosInstance } =
    useCreateUserPlatformServiceAxiosInstance();

  const queryParams = new URLSearchParams({
    limit: params.limit.toString(),
    offset: params.offset.toString(),
  });

  if (params.fromDate) {
    queryParams.append("fromDate", params.fromDate);
  }
  if (params.toDate) {
    queryParams.append("toDate", params.toDate);
  }
  if (params.receiverEmail) {
    queryParams.append("receiverEmail", params.receiverEmail);
  }

  const { data, isLoading, error } = useSWR(
    `/referral/list-issued-gift-card?${queryParams.toString()}`,
    async () => {
      const instance = createUserPlatformServiceAxiosInstance();
      const { data } = await instance.get<ListIssuedGiftCardsResponse>(
        "/referral/list-issued-gift-card",
        {
          params: {
            limit: params.limit,
            offset: params.offset,
            ...(params.fromDate && { fromDate: params.fromDate }),
            ...(params.toDate && { toDate: params.toDate }),
            ...(params.receiverEmail && {
              receiverEmail: params.receiverEmail,
            }),
          },
        },
      );
      return data;
    },
  );

  return {
    data: data ?? {
      hasNextPage: false,
      hasPreviousPage: false,
      issuedGiftCards: [],
    },
    isLoading,
    error,
  };
}
